import { useQuery } from "@tanstack/vue-query";
import { useGeoMasterDataApi } from "@/features/core-shared/composables/useGeoMasterDataApi";

export function useVenuesByCityMasterdataQuery(cityCodesRef: Ref<string[]>) {
  const { getVenuesByCityCode } = useGeoMasterDataApi();
  const isEnabled = computed(() => cityCodesRef.value.length > 0);

  return useQuery({
    queryKey: ["venues-by-city-masterdata", cityCodesRef],
    queryFn: async () => {
      const { data } = await getVenuesByCityCode(cityCodesRef.value);
      return data;
    },
    enabled: isEnabled,
  });
}
